import { MultiSelect } from "../Select";

import type { SelectProps } from "@mui/material";

interface Props {
  onChange: (value: string[]) => void;
  defaultValue?: string[];
  excludeStatuses?: string[];
  selectProps?: SelectProps;
  label?: string;
  value?: string[];
  width?: string;
}

const DEFAULT_OPTIONS = [
  {
    value: "ACTIVE",
    label: "Active",
  },
  {
    value: "BOOKED",
    label: "Booked",
  },
  {
    value: "PICKED_UP",
    label: "Picked Up",
  },
  {
    value: "DELIVERED",
    label: "Delivered",
  },
  {
    value: "BOOKING_CANCELLED",
    label: "Booking Cancelled",
  },
  {
    value: "CANCELLED",
    label: "Cancelled",
  },
  {
    value: "EXPIRED",
    label: "Expired",
  },
];

export function ShipmentStatusMultiSelect({
  onChange,
  defaultValue = [],
  excludeStatuses = [],
  selectProps,
  label,
  value,
  width,
}: Props) {
  const shipmentStatusOptions = DEFAULT_OPTIONS.filter(
    (option) => !excludeStatuses.includes(option.value),
  );

  const handleChange = (newValue: string[]) => {
    onChange(newValue);
  };

  return (
    <MultiSelect
      inputLabel={label ?? "Shipment Status"}
      defaultValue={defaultValue}
      value={value}
      onChange={handleChange}
      options={shipmentStatusOptions}
      selectProps={selectProps}
      width={width}
    />
  );
}
